var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 3.002Q12.295 3 11.5 3C7.022 3 4.782 3 3.391 4.391S2 8.021 2 12.5c0 4.478 0 6.718 1.391 8.109S7.021 22 11.5 22c4.478 0 6.718 0 8.109-1.391 1.338-1.339 1.389-3.462 1.39-7.609"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 14.135q.93-.135 1.872-.132c2.652-.056 5.239.77 7.3 2.331 1.91 1.448 3.253 3.44 3.828 5.666"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 16.896c-1.175-.595-2.391-.897-3.614-.896-1.851-.007-3.684.673-5.386 2M17 4.5c.491-.506 1.8-2.5 2.5-2.5m0 0c.7 0 2.009 1.994 2.5 2.5M19.5 2v8"
})));
export { SvgUploadImage as ReactComponent };
export default __webpack_public_path__ + "32db37778efe59e60b49602cfe0de032.svg";